export default __webpack_public_path__ + "static/media/institute-25-min.4b0bf90f.webp";